import { fromNullable } from 'maybeasy';
import { MutableRefObject } from 'react';
import { MultiValue } from 'react-select';
import { normalizeValue } from '../../../../../../NormalizeValue';
import { StringOption } from '../../../../../Options/Types';

export const handleSelectionChange =
  (
    onChange: (value: StringOption) => void,
    setOptionSelectedState: (selectedValue: StringOption) => void,
  ) =>
  (selectedOption: StringOption | MultiValue<StringOption> | null) => {
    const option = normalizeValue(selectedOption).getOrElseValue({
      value: '',
      label: '',
    });

    setOptionSelectedState(option);
    onChange(option);
  };

export const handleInputChange =
  (
    debouncer: MutableRefObject<NodeJS.Timeout | undefined>,
    setFilteringState: (filterBy: string) => void,
  ) =>
  (inputValue: string) => {
    fromNullable(debouncer.current).do(clearTimeout);
    debouncer.current = setTimeout(() => {
      setFilteringState(inputValue);
    }, 300);
  };
